import { defineStore } from 'pinia';
import { loadStripe } from '@stripe/stripe-js';

export const useStripePaymentStore = defineStore('stripePayment', () => {
    /** @type {import('vue').Ref<import('@stripe/stripe-js').Stripe | null>} */
    const stripe = ref(null);

    async function initStripe(company_stripe_id) {
        stripe.value = await loadStripe(import.meta.env.VITE_STRIPE_KEY, { stripeAccount: company_stripe_id });
    }

    return {
        stripe,
        initStripe,
    };
});
